import * as types from './mutation_types'

export default {
  pushTrackTime({ commit }, { id, time }) {
    commit(types.ADD_TIME_DATA, { id, time });
  },
};
